<template>
  <!--srcviewscompanydetailsbusinessvuehtmlStart-->

  <div id="defaultId1" class="company_detail">
    <div id="cc18ed" class="udb507 u22483 pb20">
      <div id="g2ede8" class="operations-content mb10">
        <h2 id="gf7b16" class="operations-head detail_title_20">{{ $t('ContentTabs.Industry') }}</h2>
        <div class="operations-box">
          <div class="operations-box-left">
            <el-descriptions :colon="false" :column="1" v-if="IndustryTitle ">
              <el-descriptions-item>
                <template slot="label">
                  <div class="operations-label-title">{{ $t('Industry.IndustryTitle') }}</div>
                  <div>
                  </div>
                </template>
                <div class="operations-label-text">
                  <div>{{ IndustryTitle }}</div>
                </div>
              </el-descriptions-item>
            </el-descriptions>
            <el-descriptions :colon="false" :column="1" v-if="IndustryDescription != '-'">
              <el-descriptions-item>
                <template slot="label">
                  <div class="operations-label-title">{{ $t('Industry.IndustryDescription') }}</div>
                  <div>
                  </div>
                </template>
                <div class="operations-label-text">
                  <div>{{ IndustryDescription }}</div>
                </div>
              </el-descriptions-item>
            </el-descriptions>
 
          </div>
          <div class="operations-box-right">
 
            
            <div class="industry-right-box">
              <ul>
                <li  v-if="ISICCode">
                 <div class="industry-right-box-li-box">
                  <div class="operations-label-title">{{ $t('Industry.ISIC') }} </div>
                  <div class="operations-label-text">
                  <div>{{ ISICCode }}</div>
                    </div>
                 
                 </div>
                 <div class="industry-right-box-li-box" style="margin-bottom: 0px;">
                  <div class="operations-label-title">{{ $t('Industry.ISICDescription') }}</div>
                  <div class="operations-label-text">
                  <div>{{ isicCodeDes }}</div>
                    </div>
                 </div> 
                </li>
                <li  v-if="NACECode">
                 <div class="industry-right-box-li-box">
                  <div class="operations-label-title">{{ $t('Industry.NACE') }} </div>
                  <div class="operations-label-text">
                  <div>{{ NACECode }}</div>
                    </div>
                 
                 </div>
                 <div class="industry-right-box-li-box" style="margin-bottom: 0px;">
                  <div class="operations-label-title">{{ $t('Industry.NACEDescription') }} </div>
                  <div class="operations-label-text">
                  <div>{{ naceCodeDes }}</div>
                    </div>
                 </div> 
                </li>
                <li v-if="NAICSCode">
                 <div class="industry-right-box-li-box">
                  <div class="operations-label-title">{{ $t('Industry.NAICS') }} </div>
                  <div class="operations-label-text">
                  <div>{{NAICSCode }}</div>
                    </div>
                 
                 </div>
                 <div class="industry-right-box-li-box" style="margin-bottom: 0px;">
                  <div class="operations-label-title">{{ $t('Industry.NAICSDescription') }} </div>
                  <div class="operations-label-text">
                  <div>{{ naicsCodeDes }}</div>
                    </div>
                 </div> 
                </li>
                <li v-if="csicCode">
                 <div class="industry-right-box-li-box" >
                  <div class="operations-label-title">{{ $t('Industry.CSIC') }} </div>
                  <div class="operations-label-text">
                  <div>{{ csicCode }}</div>
                    </div>
                 
                 </div>
                 <div class="industry-right-box-li-box" style="margin-bottom: 0px;">
                  <div class="operations-label-title">{{ $t('Industry.CSICDescription') }} </div>
                  <div class="operations-label-text">
                  <div>{{ csicCodeDes }}</div>
                    </div>
                 </div> 
                </li>
                <li v-if="aaaicCode">
                 <div class="industry-right-box-li-box">
                  <div class="operations-label-title">{{ $t('Industry.AAAIC') }} </div>
                  <div class="operations-label-text">
                  <div>{{ aaaicCode }}</div>
                    </div>
                 
                 </div>
                 <div class="industry-right-box-li-box" style="margin-bottom: 0px;">
                  <div class="operations-label-title">{{ $t('Industry.AAAICDescription') }} </div>
                  <div class="operations-label-text">
                  <div>{{ aaaicCodeDes }}</div>
                    </div>
                 </div> 
                </li>
                <li v-if="gicsCode">
                 <div class="industry-right-box-li-box">
                  <div class="operations-label-title">{{ $t('Industry.GICS') }}  </div>
                  <div class="operations-label-text">
                  <div>{{ gicsCode }}</div>
                    </div>
                 
                 </div>
                 <div class="industry-right-box-li-box" style="margin-bottom: 0px;">
                  <div class="operations-label-title">{{ $t('Industry.GICSDescriptio') }}  </div>
                  <div class="operations-label-text">
                  <div>{{ gicsCodeDes }}</div>
                    </div>
                 </div> 
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- tableData.length > 0 -->
   
      <!-- <PermissionDialog></PermissionDialog> -->
      <ReLogin :reLoginPop="reLoginVis"></ReLogin>
    </div>
  </div>
</template>
<script>
import {
  getCompanyIndustry,
  getIndustryStatics,
  getPartPrivilege
} from "@/api/companyApi";
import PermissionDialog from '../../../../components/power/PermissionDialog.vue';
import ReLogin from "../../../../components/ReLogin.vue";

export default {

  name: "",
  //   props: {},

  components: {
    PermissionDialog,
    ReLogin,

  },
  created() {
    this.getPartPrivilege()
    this.getList()

    this.$emit("UpdatamarkTotalList", []);

  },
  computed: {},
  data() {
    return {
      reLoginVis: false,
      powerArr: [],
      Busines: '',

      ProductsServices: '',

      options: [],
      YeraOptions: [],
      value1: "2023",
      value2: "",

      tableData: [

      ],
      data: [],

      iconactive: "computer",
      inputIndex: -1,
      editcontent: "",
      IndustryDescription: '',
      IndustryTitle:'',
      csicCode:'',
      gicsCode:'',
      icsCode:'',
      aaaicCode:'',
      ISICCode: '',
      NACECode: '',
      naceCodeDes:'',
      isicCodeDes:'',

      naicsCodeDes:'',
      gicsCodeDes:'',
      csicCodeDes:'',
      aaaicCodeDes:'',
      Employees: '',
      NAICSCode: '',
      isicCode: '',
      selectTypevalue: '',
      // insertData
      // srcviewscompanydetailsbusinessvueDataStart

      // hangyefenxiKey
      hangyefenxiKey: 0,
      echartsdata: []
      // srcviewscompanydetailsbusinessvueDataEnd
    };
  },
  methods: {
    clickOutSide3() {

      if (this.$refs.upSelect3) {
        this.$refs.upSelect3.visible = false

      }

    },
    clickOutSide4() {

      if (this.$refs.upSelect4) {
        this.$refs.upSelect4.visible = false

      }

    },
    getPartPrivilege() {
      getPartPrivilege({
        moduleId: this.$route.query.idpower
      }).then(res => {
        this.powerArr[0] = (res.data.filter(item => item.id == '428'))[0]
        this.powerArr[1] = (res.data.filter(item => item.id == '429'))[0]
      })

    },
    selectType() {
      this.options.map(item => {
        if (item.id == this.value2) {
          this.selectTypevalue = item.name
        }
      })
      getIndustryStatics({
        aaaId: this.$route.query.id3a,
        industryCode: this.isicCode,
        filter: this.value2,
        year: this.value1
      }).then(res => {
        if (res.code == 200) {
          this.tableData = res.data.staticItems
          let dotCharts = res.data.dotCharts
          dotCharts.map(item => {
            if (this.value2 == '4') {
              if (item.yAxis == '3A1') {
                item.Create = 'AAA'
              }
              if (item.yAxis == '3A2') {
                item.Create = 'AA+'
              }
              if (item.yAxis == '3A3') {
                item.Create = 'AA'
              }
              if (item.yAxis == '3A4') {
                item.Create = 'AA-'
              }
              if (item.yAxis == '3A5') {
                item.Create = 'A+'
              }
              if (item.yAxis == '3A6') {
                item.Create = 'A'
              }
              if (item.yAxis == '3A7') {
                item.Create = 'A-'
              }
              if (item.yAxis == '3A8') {
                item.Create = 'BBB+'
              }
              if (item.yAxis == '3A9') {
                item.Create = 'BBB'
              }
              if (item.yAxis == '3A10') {
                item.Create = 'BBB-'
              }
              if (item.yAxis == '3A11') {
                item.Create = 'BB+'
              }
              if (item.yAxis == '3A12') {
                item.Create = 'BB'
              }
              if (item.yAxis == '3A13') {
                item.Create = 'BB-'
              }
              if (item.yAxis == '3A14') {
                item.Create = 'B+'
              }
              if (item.yAxis == '3A15') {
                item.Create = 'B'
              }
              if (item.yAxis == '3A16') {
                item.Create = 'B-'
              }
              if (item.yAxis == '3A17') {
                item.Create = 'CCC'
              }
              if (item.yAxis == '3A18') {
                item.Create = 'CC'
              }
              if (item.yAxis == '3A19') {
                item.Create = 'C'
              }
            } else {
              item.Create = item.yAxis.replace('3A', '') ? item.yAxis.replace('3A', '') : ''
            }

          })
          // .slice(0, 100)
          // 收入
          let xAxisnum = dotCharts.filter(i => i.financialIndex == 'income' && i.xAxis > 0).map(item => {
            return [item.xAxis * 10000000, item.yAxis.replace('3A', '') ? item.yAxis.replace('3A', '') : '', item.num, 0, item.Create]
          })
          //  利润
          let yAxisnum = dotCharts.filter(i => i.financialIndex == 'profit' && i.xAxis > 0).map(item => {
            return [item.xAxis * 10000000, item.yAxis.replace('3A', '') ? item.yAxis.replace('3A', '') : '', item.num, 0, item.Create]
          })
          // 总资产
          let zAxisnum = dotCharts.filter(i => i.financialIndex == 'asset' && i.xAxis > 0).map(item => {
            return [item.xAxis * 10000000, item.yAxis.replace('3A', '') ? item.yAxis.replace('3A', '') : '', item.num, 0, item.Create]
          })
          // 资产回报率
          // let wAxisnum = dotCharts.filter(i => i.financialIndex == 'roa' && i.xaxis > 0).map(item => {
          //   return [item.xaxis, item.yaxis.replace('3A', '') ? item.yaxis.replace('3A', '') : '', item.num, 0]
          // })

          const data = [xAxisnum, yAxisnum, zAxisnum,]

          this.echartsdata = data
          this.$nextTick(() => {
            // 在 DOM 更新后执行代码
            this.industryEchart();
            this.IndustryStatisticschart()
          });
        }

      })


    },
    getList() {
      getCompanyIndustry({
        id3a: this.$route.query.id3a,
      }).then(res => {
        if (res.code == 200) {
          this.IndustryDescription = res.data.industryDescription
          this.IndustryTitle=res.data.industryTitle
          this.gicsCode=res.data.gicsCode
          this.csicCode=res.data.csicCode
          this.icsCode=res.data.icsCode
          this.aaaicCode=res.data.aaaicCode
          this.ISICCode = res.data.isicCode
          this.isicCode = res.data.isicCode
          this.NAICSCode = res.data.naicsCode
          this.NACECode = res.data.naceCode
          this.naceCodeDes=res.data.naceCodeDes
          this.isicCodeDes=res.data.isicCodeDes
          this.csicCodeDes=res.data.csicCodeDes
          this.naicsCodeDes=res.data.naicsCodeDes
          this.aaaicCodeDes=res.data.aaaicCodeDes
          this.gicsCodeDes=res.data.gicsCodeDes
          this.Employees = res.data.employees
          this.YeraOptions = res.data.yearFilter
          this.value1 = this.YeraOptions[0].id
          this.options = res.data.selectConditions
          this.value2 = res.data.selectConditions[0].id
          this.selectTypevalue = res.data.selectConditions[0].name
          this.tableData = res.data.staticItems
          // .slice(0, 150)
          let dotCharts = res.data.dotCharts
          dotCharts.map(item => {
            if (this.value2 == '4') {
              if (item.yAxis == '3A1') {
                item.Create = 'AAA'
              }
              if (item.yAxis == '3A2') {
                item.Create = 'AA+'
              }
              if (item.yAxis == '3A3') {
                item.Create = 'AA'
              }
              if (item.yAxis == '3A4') {
                item.Create = 'AA-'
              }
              if (item.yAxis == '3A5') {
                item.Create = 'A+'
              }
              if (item.yAxis == '3A6') {
                item.Create = 'A'
              }
              if (item.yAxis == '3A7') {
                item.Create = 'A-'
              }
              if (item.yAxis == '3A8') {
                item.Create = 'BBB+'
              }
              if (item.yAxis == '3A9') {
                item.Create = 'BBB'
              }
              if (item.yAxis == '3A10') {
                item.Create = 'BBB-'
              }
              if (item.yAxis == '3A11') {
                item.Create = 'BB+'
              }
              if (item.yAxis == '3A12') {
                item.Create = 'BB'
              }
              if (item.yAxis == '3A13') {
                item.Create = 'BB-'
              }
              if (item.yAxis == '3A14') {
                item.Create = 'B+'
              }
              if (item.yAxis == '3A15') {
                item.Create = 'B'
              }
              if (item.yAxis == '3A16') {
                item.Create = 'B-'
              }
              if (item.yAxis == '3A17') {
                item.Create = 'CCC'
              }
              if (item.yAxis == '3A18') {
                item.Create = 'CC'
              }
              if (item.yAxis == '3A19') {
                item.Create = 'C'
              }
            } else {
              item.Create = item.yaxis.replace('3A', '') ? item.yaxis.replace('3A', '') : ''
            }

          })
          // 收入
          let xAxisnum = dotCharts.filter(i => i.financialIndex == 'income' && i.xaxis > 0).map(item => {
            return [item.xaxis * 10000000, item.yaxis.replace('3A', '') ? item.yaxis.replace('3A', '') : '', item.num, 0, item.Create]
          })
          //  利润
          let yAxisnum = dotCharts.filter(i => i.financialIndex == 'profit' && i.xaxis > 0).map(item => {
            return [item.xaxis * 10000000, item.yaxis.replace('3A', '') ? item.yaxis.replace('3A', '') : '', item.num, 0, item.Create]
          })
          // 总资产
          let zAxisnum = dotCharts.filter(i => i.financialIndex == 'asset' && i.xaxis > 0).map(item => {
            return [item.xaxis * 10000000, item.yaxis.replace('3A', '') ? item.yaxis.replace('3A', '') : '', item.num, 0, item.Create]
          })
          // 资产回报率
          // let wAxisnum = dotCharts.filter(i => i.financialIndex == 'roa' && i.xaxis > 0).map(item => {
          //   return [item.xaxis, item.yaxis.replace('3A', '') ? item.yaxis.replace('3A', '') : '', item.num, 0]
          // })

          const data = [xAxisnum, yAxisnum, zAxisnum,]
          this.echartsdata = data
          // this.$nextTick(() => {
          //   // 在 DOM 更新后执行代码
          //   this.industryEchart();
          //   this.IndustryStatisticschart()
          // });
        } else {
          this.IndustryDescription = ''
          this.ISICCode = ''
          this.isicCode = ''
          this.NAICSCode = ''
          this.NACECode = ''
          this.Employees = ''
          this.YeraOptions = ''
        }

      }).catch(err => {
        this.reLoginVis = String(err).includes('403')
      })
    },

    edit(content) {
      this.editcontent = content;

      //   this.tableData.push({ ...this.tableData[index-1] });
    },
    // insertMethod
    // srcviewscompanydetailsbusinessvueMethodStart
    // returnPage
    handleEdit(index, row) {
    },
    IndustryStatisticschart() {
      let dataone = [];
      let datanum = [];
      this.tableData.map(item => {
        dataone.push(item.subjectCompany)
        datanum.push(item.sameIndustry)
      })
     
      let that = this;
      this.echartsBox = this.$echarts.init(this.$refs.IndustryStatisticschart);
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: dataone,
            axisTick: {
              alignWithLabel: true,
            },
            axisLabel: {
              // 设置文本的旋转角度
              rotate: 0,
              // 设置文本的最大宽度
              width: 130,
              // 使用 formatter 进行文本处理
              formatter: function (value) {
                // 如果文本长度超过一定值，则进行省略
                return value.length > 5 ? value.substring(0, 5) + '...' : value;
              }
            }
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "Direct",
            type: "bar",
            barWidth: "60%",
            data: datanum,
            barWidth: "80px", // 柱子宽度
            itemStyle: {
              color: "#1290C9", // 柱子颜色
            },
          },
        ],
      };
      this.echartsBox.setOption(option);
    },

    cellClassName({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return "highlight-cell"; // 设置你想要的背景色
      }
    },
    addInput(index) {
      this.inputIndex = index;
      this.tableData.push({ ...this.tableData[index - 1] });
    },
    initCharStyle() { // 初始化图表的样式
      let wt = document.querySelector('.supply_chart2').getBoundingClientRect().width
      let ht = document.querySelector('.supply_chart2').getBoundingClientRect().height
      document.querySelector('.supply_chart2').style.width = wt + 'px' // 强制添加样式
      document.querySelector('.supply_chart2').style.height = ht + 'px'
      document.querySelector('.supply_chart1').style.width = wt + 'px' // 强制添加样式
      document.querySelector('.supply_chart1').style.height = ht + 'px'
    },
    async industryEchart() {
      let data = this.echartsdata
      let that = this;

      this.initCharStyle() // 把尺寸大小都计算好之后，然后再渲染图表内容
      await this.$nextTick(); // 等待DOM更新

      this.echartsBox = this.$echarts.init(this.$refs.SupplyChainEchart);
      let copyCompany = JSON.parse(localStorage.getItem('CompanyBase')).companyName

      const option = {
        grid: {
          left: '3%',
          right: '5%',
          bottom: '0%',
          top: '10%',
          containLabel: true
        },
        color: ['#0064d2', '#f5af02', '#86b817',],
        tooltip: {
          // trigger: 'axis',
          showDelay: 0,
          formatter: function (params) {
            if (params.color === '#DD5145') {
              if (params.value[0] < 1000000) {
                return 'Subject Company: ' + copyCompany + '<br/>' + params.seriesName + '：' +
                  (params.value[0] / 1000).toFixed(2) + (params.seriesName == 'roa' ? '%<br/>' : 'k<br/>') +
                  that.selectTypevalue +
                  '' + params.value[1]
              } else if (params.value[0] >= 1000000 && params.value[0] < 1000000000) {
                return 'Subject Company: ' + copyCompany + '<br/>' + params.seriesName + '：' +
                  (params.value[0] / 1000000).toFixed(2) + (params.seriesName == 'roa' ? '%<br/>' : 'M<br/>') +
                  that.selectTypevalue +
                  '' + params.value[1]
              } else if (params.value[0] >= 1000000000 && params.value[0] < 1000000000000) {
                return 'Subject Company: ' + copyCompany + '<br/>' + params.seriesName + '：' +
                  (params.value[0] / 1000000000).toFixed(2) + (params.seriesName == 'roa' ? '%<br/>' : 'B<br/>') +
                  that.selectTypevalue +
                  '' + params.value[1]
              } else {
                return 'Subject Company: ' + copyCompany + '<br/>' + params.seriesName + '：' + params.value[0] + '~' +
                  (params.value[0] / 1000000000000).toFixed(2) + (params.seriesName == 'roa' ? '%<br/>' : 'B<br/>') +
                  that.selectTypevalue +
                  '' + params.value[1]
              }
            } else {
              if (params.value[0] < 1000000) {
                return params.seriesName + '：' +
                  (params.value[0] / 1000).toFixed(2) + (params.seriesName == 'roa' ? '%<br/>' : 'k<br/>') + that.selectTypevalue + ': ' +

                  '' + params.value[4] + '<br/>' +
                  'Number of Company: ' + params.value[2]
              } else if (params.value[0] >= 1000000 && params.value[0] < 1000000000) {
                return params.seriesName + '：' +
                  (params.value[0] / 1000000).toFixed(2) + (params.seriesName == 'roa' ? '%<br/>' : 'M<br/>') + that.selectTypevalue + ': ' +

                  '' + params.value[4] + '<br/>' +
                  'Number of Company: ' + params.value[2]
              } else if (params.value[0] >= 1000000000 && params.value[0] < 1000000000000) {
                return params.seriesName + '：' +
                  (params.value[0] / 1000000000).toFixed(2) + (params.seriesName == 'roa' ? '%<br/>' : 'B<br/>') + that.selectTypevalue + ': ' +
                  '' + params.value[4] + '<br/>' +
                  'Number of Company: ' + params.value[2]
              } else {
                return params.seriesName + '：' + params.value[0] + '~' +
                  (params.value[0] / 1000000000000).toFixed(2) + (params.seriesName == 'roa' ? '%<br/>' : 'B<br/>') + that.selectTypevalue + ': ' +

                  '' + params.value[4] + '<br/>' +
                  'Number of Company: ' + params.value[2]
              }
            }
          }
        },
        xAxis: {
          show: true,
          type: 'log',
          scale: true,
          max: 100000000,
          min: 1000,
          axisLabel: {
            show: true,
            // formatter: '{value}',
            formatter: (value) => {
              if (value < 1000000) {
                return value / 1000 + 'k'
              } else if (value < 1000000000) {
                return value / 1000000 + 'm'
              } else if (value > 1000000000000) {
                return value / 1000000000 + 'b'
              } else {
                return value / 1000000000 + 'b'
              }
            },
            color: '#8398BB'
          },
          splitLine: {
            lineStyle: {
              width: 1,
              type: 'dashed',
              color: '#8398BB'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: '#142746'
            }
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          // max: that.value2=='2'?'2025':'',
          min: that.value2 == '2' ? '2010' : 1,
          // splitNumber: 4,
          inverse: true,
          splitLine: {
            lineStyle: {
              width: 1,
              type: 'dashed',
              color: '#8398BB'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: '#142746'
            }
          },
          axisLabel: {
            fontSize: 18,
            color: '#8398BB',
            // 后期单位
            formatter: function (value) {
              if (that.value2 == '4') {
                if (value == 1) {
                  return 'AAA';
                }
                if (value == 2) {
                  return 'AA+';
                }
                if (value == 3) {
                  return 'AA';
                }
                if (value == 4) {
                  return 'AA-';
                }
                if (value == 5) {
                  return 'A+';
                }
                if (value == 6) {
                  return 'A';
                }
                if (value == 7) {
                  return 'A-';
                }
                if (value == 8) {
                  return 'BBB+';
                }
                if (value == 9) {
                  return 'BBB';
                }
                if (value == 10) {
                  return 'BBB-';
                }
                if (value == 11) {
                  return 'BB+';
                }
                if (value == 12) {
                  return 'BB';
                }
                if (value == 13) {
                  return 'BB-';
                }
                if (value == 14) {
                  return 'B+';
                }
                if (value == 15) {
                  return 'B';
                }
                if (value == 16) {
                  return 'B-';
                }
                if (value == 17) {
                  return 'CCC';
                }
                if (value == 18) {
                  return 'CC';
                }
                if (value == 19) {
                  return 'C';
                }
              } else {
                return value;
              }

              // 不进行千分位格式化
            }
          },
          axisTick: {
            show: false
          }
        },
        legend: {
          right: '10%',
          data: ['Revenue', 'Earning', 'Total Assets',],
          textStyle: {
            fontSize: 14
          }
        },
        series: [
          {
            name: 'Revenue',
            data: data[0],
            type: 'scatter',
            itemStyle: {
              color: function (params) {
                if (params.data && params.data[3] === '1') {
                  return '#DD5145'
                } else {
                  return params.color
                }
              }
            },
            symbolSize: function (data) {
              if (data && data[2]) {
                return Math.log(data[2]) + 12
              }
              return 8
            }
          },
          {
            name: 'Earning',
            data: data[1],
            type: 'scatter',
            itemStyle: {
              color: function (params) {
                if (params.data && params.data[3] === '1') {
                  return '#DD5145'
                } else {
                  return params.color
                }
              }
            },
            symbolSize: function (data) {
              if (data && data[2]) {
                return Math.log(data[2]) + 13
              }
              return 8
            }
          },
          {
            name: 'Total Assets',
            data: data[2],
            type: 'scatter',
            itemStyle: {
              shadowBlur: 6,
              shadowColor: 'rgba(68, 99, 1567, 0.45)',
              shadowOffsetY: 4,
              opacity: 1,
              color: function (params) {
                if (params.data && params.data[3] === '1') {
                  return '#DD5145'
                } else {
                  return params.color
                }
              }
            },
            symbolSize: function (data) {
              if (data && data[2]) {
                return Math.log(data[2]) + 12
              }
              return 8
            }
          },
          // {
          //   name: 'roa',
          //   data: data[3],
          //   type: 'scatter',
          //   itemStyle: {
          //     color: function (params) {
          //       if (params.data && params.data[3] === '1') {
          //         return '#DD5145'
          //       } else {
          //         return params.color
          //       }
          //     }
          //   },
          //   symbolSize: function (data) {
          //     if (data && data[3]) {
          //       return Math.log(data[3]) + 8
          //     }
          //     return 8
          //   }
          // },
        ]
      }
      this.echartsBox.setOption(option);
    },
    // srcviewscompanydetailsbusinessvueMethodEnd
  },

};
</script>
<style scoped>
.ua915f {
  margin-right: 0em;
  padding-left: 0.5em;
  padding-right: 0.5em;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  margin-top: 0em;
  margin-left: 0em;
  margin-bottom: 0em;
}

.operations-head {
  font-size: 1.857142857143rem;

  color: #1a2332;
  text-align: left;
  font-style: normal;
  display: flex;
  justify-content: space-between;
  height: 2.85rem;
  align-items: center;
  font-family: 'DMSans Bold';
}

.operations-content {
  padding: 2.142857142857143rem 2.857142857142857rem;
  background: #FFFFFF;
  box-shadow: 0rem 0.14285714285714285rem 1rem 0rem rgba(0, 0, 0, 0.12);
  border-radius: 0.2857142857142857rem;
}

.operations-box {
  margin-top: 2.142857142857143rem;
  display: flex;
  justify-content: space-between;
}

/deep/.el-descriptions__title {
  font-size: 1.857142857143rem;
  font-family: 'DMSans Bold';
  color: #1a2332;
  text-align: left;
  font-style: normal;
}

/deep/ .el-descriptions-item__label {
  display: block !important;
  margin-right: 2.142857142857143rem !important;
  /* padding-bottom: 2.142857142857143rem !important; */
}

.operations-label-title {
  min-width: 15.2rem;
  font-size: 1.285714285714286rem;
  font-family: 'DMSans Bold';
  color: #1a2332;
  line-height: 1.85rem;
}

.operations-label-text {
  font-size: 1.285714285714286rem;

  color: #29445d;
  line-height: 1.5;
  width: 100%;
  /* text-align: justify; */
}

/deep/ .el-textarea__inner {
  font-size: 1.285714285714286rem;
  color: #29445d;
}

.ViewMore {
  line-height: 1.8571428571428572rem;
  text-align: left;
  font-style: normal;
  text-decoration-line: underline;
  margin-left: 2.142857142857143rem;
}

.operations-box-left {
  margin-right: 4.285714285714286rem;
  width: 45%;
}

.jiange {
  color: #cccccc;
  margin: 0 1.42rem;
  font-size: 1.4285714285714286rem;
  /* font-size: 1.25em; */
}

.contclass {
  font-size: 1.4285714285714286rem;
  color: #1290c9;
  font-style: normal;
  height: 3.57rem;
  background: #F5F5F5;
  border-radius: 1.78rem;
  display: flex;
  align-items: center;
  padding: 0.21rem;


}

.last-colmun {
  padding: 2rem 0rem;
  border-bottom: 0.07142857142857142rem solid #ebeef5;
}

.dingwei {
  position: absolute;
  top: -2.142857142857143rem;
  right: 0rem;
}

/deep/ .el-descriptions-item__cell {
  padding-bottom: 2.142857142857143rem !important;
}

.icon {
  margin: 0 1.4285714285714286rem;
}

/deep/ .highlight-cell {
  background-color: #f2f5f9 !important;
}

/deep/ .el-table .cell {
  color: #1a2332;
  line-height: 2.14rem;
}

/deep/ .el-table th.el-table__cell>.cell {
  font-family: 'DMSans Bold';
}

/deep/ .el-table {
  margin-top: 1.4285714285714286rem;
}

/deep/ .el-table th.el-table__cell {
  background-color: #f2f5f9 !important;
}

.table-content {
  height: 4rem !important;
  line-height: 4rem;
}

.operations-box-right {
  width:46%;

}

.svgbg {

  background-color: #FFFFFF;
}

.svgclass {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50%;
  height: 3.142857142857143rem;
  border-radius: 1.5714285714285714rem;
}

.operations-box-lefttwo {
  display: flex;
  height: 0px;
  flex-direction: column;
  width: 100%;
  background: #ffffff;
  box-shadow: 0rem 0.14285714285714285rem 1rem 0rem rgba(0, 0, 0, 0.12);
  border-radius: 0.2857142857142857rem;
  padding: 2.142857142857143rem 2.857142857142857rem;
  height: 100%;
}

.operations-headtwo {
  justify-content: flex-end;
  margin-bottom: 1.4285714285714286rem;
}

.supply div {
  width: 71.28em !important;
}

.supply_chart {
  flex: auto;
  height: 0px;
}

.uc1096 {
  width: 62%;
}
.bg-descriptions{
  /* background: #F5F5F5; */
border-radius: 4px;
}
.industry-right-box li{
  padding: 1.42857143rem 2.14286714rem; 
  background: #F5F5F5;
  border-radius: 4px;
  margin-bottom: 1.14285714rem;
}
.industry-right-box-li-box{
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
}
</style>